import { ReactElement } from 'react';

interface TooltipProps {
  text: string;
  children: ReactElement;
  position?: 'top' | 'bottom' | 'left' | 'right';
  className?: string;
}

const positionClasses: Record<NonNullable<TooltipProps['position']>, string> = {
  top:    'bottom-full left-1/2 -translate-x-1/2 mb-2',
  bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
  left:   'right-full top-1/2 -translate-y-1/2 mr-2',
  right:  'left-full top-1/2 -translate-y-1/2 ml-2',
};

const arrowClasses: Record<NonNullable<TooltipProps['position']>, string> = {
  top:    'top-full left-1/2 -translate-x-1/2 border-t-slate-800',
  bottom: 'bottom-full left-1/2 -translate-x-1/2 border-b-slate-800',
  left:   'left-full top-1/2 -translate-y-1/2 border-l-slate-800',
  right:  'right-full top-1/2 -translate-y-1/2 border-r-slate-800',
};

export function Tooltip({ text, children, position = 'top', className }: TooltipProps) {
  return (
    <div className={className ? `relative group ${className}` : 'relative group inline-flex'}>
      {children}
      <span
        role="tooltip"
        className={`pointer-events-none absolute z-50 whitespace-nowrap rounded-lg
                    bg-slate-800 px-2.5 py-1 text-[11px] font-medium text-white shadow-lg
                    opacity-0 group-hover:opacity-100 transition-opacity duration-150 delay-200
                    ${positionClasses[position]}`}
      >
        {text}
        <span
          className={`absolute border-4 border-transparent ${arrowClasses[position]}`}
        />
      </span>
    </div>
  );
}
